import {
  GeneralSettingsTab,
  SettingsTabDef,
} from '../interfaces/Settings/SettingsTab';
import { StoreSettings } from '../pages/GeneralSettings/TabContent/StoreSettings';
import { MailSettings } from '../pages/GeneralSettings/TabContent/MailSettings';
import { PartnerSettings } from '../pages/GeneralSettings/TabContent/PartnerSettings';
import { ShipmentSettings } from '../pages/GeneralSettings/TabContent/ShipmentSettings';
import { PointSystemSettings } from '../pages/GeneralSettings/TabContent/PointSystemSettings';
import { PricingSettings } from '../pages/GeneralSettings/TabContent/PricingSettings';
import { PaymentSettings } from '../pages/GeneralSettings/TabContent/PaymentSettings';
import { InvoiceSettings } from '../pages/GeneralSettings/TabContent/InvoiceSettings';
import { AnalyticsSettings } from '../pages/GeneralSettings/TabContent/AnalyticsSettings';
import { AiSettings } from '../pages/GeneralSettings/TabContent/AiSettings';

export const availableGeneralSettingsTabs: SettingsTabDef<GeneralSettingsTab>[] =
  [
    {
      kind: GeneralSettingsTab.STORE,
      name: 'Mağaza',
      path: 'store',
      element: <StoreSettings />,
    },
    // {
    //   kind: GeneralSettingsTab.SMS,
    //   name: 'SMS',
    //   path: 'sms',
    //   element: <SmsSettings />,
    // },
    {
      kind: GeneralSettingsTab.EMAIL,
      name: 'E-Posta',
      path: 'email',
      element: <MailSettings />,
    },
    {
      kind: GeneralSettingsTab.PARTNER,
      name: 'Partner Platformlar',
      path: 'partners',
      element: <PartnerSettings />,
    },
    {
      kind: GeneralSettingsTab.SHIPMENT,
      name: 'Kargo',
      path: 'shipment',
      element: <ShipmentSettings />,
    },
    {
      kind: GeneralSettingsTab.PAYMENT,
      name: 'Ödeme',
      path: 'payment',
      element: <PaymentSettings />,
    },
    {
      kind: GeneralSettingsTab.INVOICE,
      name: 'Faturalama',
      path: 'invoice-settings',
      element: <InvoiceSettings />,
    },
    {
      kind: GeneralSettingsTab.POINT_SYSTEM,
      name: 'Puan Sistemi',
      path: 'point-system',
      element: <PointSystemSettings />,
    },
    {
      kind: GeneralSettingsTab.PRICING,
      name: 'Fiyatlama',
      path: 'pricing',
      element: <PricingSettings />,
    },
    {
      kind: GeneralSettingsTab.ANALYTICS,
      name: 'Analitik',
      path: 'analytics',
      element: <AnalyticsSettings />,
    },
    {
      kind: GeneralSettingsTab.AI,
      name: 'Yapay Zeka',
      path: 'ai',
      element: <AiSettings />,
    },
  ];
